<template>
  <el-form ref="form" :model="form" style="position: relative;margin-top: -6px">
    <template>
      <div style="position: absolute;top:-56px;right:0" v-if="editOpType">
        <gj-tool-group :sort-gjtable="$refs.gjTable" setting :table-name="'delivery-plan-products-edit'" :table-columns="columns"></gj-tool-group>
      </div>
      <div style="display: flex;justify-content: space-between;align-items: center" v-if="addOpType">
        <div>
          <gj-button type="primary" @click="addProducts">添加商品</gj-button>
          <gj-dropdown placement="bottom-start" style="margin-left:8px;margin-right:8px">
          <gj-button
            ><span>导入商品</span><i class="el-icon-arrow-down el-icon--right"></i
          ></gj-button>
          <template #dropdown>
            <gj-dropdown-item
              @click="importProduct('msku')"
              >按MSKU导入商品</gj-dropdown-item
            >
            <gj-dropdown-item
              @click="importProduct('fnsku')"
              >按FNSKU导入商品</gj-dropdown-item
            >
          </template>
        </gj-dropdown>
          <!-- <gj-button @click="importProduct">导入商品</gj-button> -->
          <gj-button type="text" @click="deleteProduct(selectedRows)">移除</gj-button>
        </div>
        <div>
          <gj-tool-group setting :table-name="'delivery-plan-products-add'" :sort-gjtable="$refs.gjTable"
                         :table-columns="columns"></gj-tool-group>
        </div>
      </div>
    </template>
    <gj-table
        ref="gjTable"
        :selection="!editOpType"
        :index="false"
        name="purchasePlanAddProduct"
        :data="form.items"
        :columns="columns"
        :offsetHeight="50"
        :scroll-y="{gt: -1}"
        border>
      <template v-slot:imageUrl="{row}">
         <gj-image :src="row.imageUrl" :tag="row.productType === 'Assembly' ? '组':''" :tag-color="'#1F6EEF'"></gj-image>
      </template>
      <template v-slot:msku="{ row }">
        <div>
          <gj-text width="82%">{{ row.msku }}</gj-text>
          <span v-if="row.msku" v-copy="row.msku" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
        </div>
        <div>
          <gj-text width="82%">{{ row.fnsku }}</gj-text>
          <span v-if="row.fnsku" v-copy="row.fnsku" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
        </div>
      </template>
      <!--  物流方式批量    -->
      <template v-slot:header:transportIds>
        物流方式
        <el-popover placement="bottom" width="220" v-if="!batchEdit">
          <div style="margin-left: 10px">
            <span class="popover-header">物流方式</span>
            <br><br>
            <gj-select v-model="transportValue"
                       :options="transportOption"
                       placeholder="请选择"
                       width="200px">
            </gj-select>
          </div>
          <div style="text-align: right; margin: 10px">
            <gj-button size="mini" @click="hidePopover">取消</gj-button>
            <gj-button type="primary" size="mini" @click="batchTransportId">确定</gj-button>
          </div>
          <gj-button type="text" slot="reference">批量</gj-button>
        </el-popover>
      </template>
      <!-- 发货仓库批量   -->
      <template v-slot:header:warehouseId>
        发货仓库
        <el-popover placement="bottom" width="220" trigger="click">
          <div style="margin-left: 10px">
            <span class="popover-header">发货仓库</span>
            <br><br>
            <gj-warehouse-select
                :fba="false"
                :active="true"
                v-model="warehouseValue"
                placeholder="请选择"
                width="200px">
            </gj-warehouse-select>
          </div>
          <div style="text-align: right; margin: 10px">
            <gj-button size="mini" @click="hidePopover">取消</gj-button>
            <gj-button type="primary" size="mini" @click="batchWarehouse">确定</gj-button>
          </div>
          <gj-button type="text" slot="reference">批量</gj-button>
        </el-popover>
      </template>
      <!--  单箱数量    -->
      <template v-slot:singleQuantity="{ row, index }">
        <el-form-item :prop="`items.${index}.singleQuantity`" class="gj-table-item"
                      :rules="[$gjMaxRule(999999, '数量需小于6位')]">
          <gj-input v-model="row.singleQuantity" @change="computedShipedPlanQuantity(row,'singleQuantity')" :max="12"
                    style="width: 98%" placeholder="" v-number.positive></gj-input>
        </el-form-item>

      </template>
      <!--  箱数     -->
      <template v-slot:packageQuantity="{ row, index }">
        <el-form-item :prop="`items.${index}.packageQuantity`" class="gj-table-item"
                      :rules="[$gjMaxRule(999999, '箱数需小于6位')]">
          <gj-input v-model="row.packageQuantity" @change="computedShipedPlanQuantity(row,'packageQuantity')" :max="12"
                    style="width: 98%" placeholder="" v-number.positive></gj-input>
        </el-form-item>
      </template>
      <!--  计划发货量    -->
      <template v-slot:shipedPlanQuantity="{ row, index }">
        <el-form-item :prop="`items.${index}.shipedPlanQuantity`" class="gj-table-item"
                      :rules="[{ required: true, message: '请填写计划发货量', trigger: ['blur','change'] }]">
          <gj-input :ref="`items${index}shipedPlanQuantity`"
                    :class="`items${index}shipedPlanQuantity`"
                     v-model="row.shipedPlanQuantity"
                    @change="computedShipedPlanQuantity(row,'shipedPlanQuantity')"
                    v-number.positive></gj-input>
        </el-form-item>
      </template>
      <!--  物流方式    -->
      <template v-slot:transportId = "{index, row}">
        <gj-select
            v-model="row.transportId"
            :options="batchEdit ? transportOptionList[row.countryCode] : transportOption"
            @change="changeTransportId(row.transportId,row)"
            placeholder="请选择"
            width="98%">
        </gj-select>
      </template>
      <!-- 发货仓库-->
      <template v-slot:warehouseId ="{index, row}">
        <gj-warehouse-select
            :fba="false"
            :active="true"
            v-model="row.warehouseId"
            placeholder="请选择"
            width="150px"
            @input="value => debounceWarehouseInfo(value, row)"
        >
        </gj-warehouse-select>
      </template>
      <template v-slot:areCasesRequired = "{row, index}">
        <el-form-item :prop="`items.${index}.areCasesRequired`" class="gj-table-item"
                      :rules="[{ required: true, message: '请选择包装类型', trigger: ['blur','change'] }]">
          <gj-select
              v-model="row.areCasesRequired"
              :options="[{id: false, text: '混装'},{id: true, text: '原厂包装'}]"
              placeholder="包装类型"
              width="98%"
          ></gj-select>
        </el-form-item>

      </template>

      <template v-slot:sku="{row}">
        <div>
          <gj-tooltip class="value" :text-line="1" :content="row.productName">
            {{ row.productName | defaultShow }}
          </gj-tooltip>
        </div>
        <div>{{ row.sku | defaultShow }}
          <span v-if="row.sku" v-copy="row.sku" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
        </div>
      </template>
      <!-- 可用量|已下达|计划入库 -->
      <template v-slot:deliveryPlanInbound="{ row }">
        <div style="display: flex;justify-content: center">
              <span>
                  {{ row.availableQuantity | defaultShow }};&nbsp;{{ row.alreadyOrderQuantity | defaultShow }};
              &nbsp;{{ row.planWarehouseQuantity | defaultShow }}
              </span>
          <gj-popover trigger="hover" placement="bottom" width="600"
                      v-if="row.productType=== 'Assembly' && row.warehouseId">
            <template>
              <div>
                <div class="maxNum">
                  <div>最大装配量：<span style="color: #EFA621;">{{ maxTableDataVo.maxAssemblyQuantity }}</span></div>
                </div>
                <gj-table
                    :columns="maxNumColumns"
                    ref="gjTable2"
                    :index="false"
                    name="maxNumTable"
                    :data="maxTableDataVo.voList"
                    :loading="maxLoading"
                    :size="'has-picture'"
                    :adapt-height="false"
                    :height="300"
                >
                  <template v-slot:skuName="{row}">
                    <gj-text width="90%">{{ row.productName }}</gj-text>
                    <br>
                    <gj-text width="90%">{{ row.sku }}</gj-text>
                    <br>
                  </template>
                </gj-table>
              </div>
            </template>
            <div slot="reference" style="margin-left: 5px;color: #1F6EEF;">
              <i class="el-icon-connection" @mouseover="getMaxNums(row.sku, row.warehouseId)"></i>
            </div>
          </gj-popover>
        </div>
      </template>
      <!-- 包装尺寸 -->
      <template v-slot:package="{ row }">
        <div class="packageContainer">
          <el-input v-model="row.packageL" class="package L" placeholder="长" size="small" v-number.price></el-input>
          <el-input v-model="row.packageW" class="package W" placeholder="宽" size="small" v-number.price></el-input>
          <el-input v-model="row.packageH" class="package H" placeholder="高" size="small" v-number.price></el-input>
        </div>
      </template>
      <!-- 箱规尺寸 -->
      <template v-slot:carton="{ row }">
        <div class="packageContainer">
          <el-input v-model="row.cartonSizeL" class="package L" placeholder="长" size="small" v-number.price
                    @change="changeTransportId(row.cartonSizeL,row)"></el-input>
          <el-input v-model="row.cartonSizeW" class="package W" placeholder="宽" size="small" v-number.price
                    @change="changeTransportId(row.cartonSizeW,row)"></el-input>
          <el-input v-model="row.cartonSizeH" class="package H" placeholder="高" size="small" v-number.price
                    @change="changeTransportId(row.cartonSizeH,row)"></el-input>
        </div>
      </template>
      <!-- 装箱总体积 -->
      <template v-slot:cartonSize="{ row }">
        {{ calcCartonSize(row.cartonSizeL, row.cartonSizeW, row.cartonSizeH, row.packageQuantity) | defaultShow }}
      </template>
      <!-- 单品计费重 -->
      <template v-slot:singleProductVolumeWeight="{ row }">
        {{ row.singleProductVolumeWeight || 0 }}
      </template>
      <!-- 单品净重 -->
      <template v-slot:singleProductNetWeight="{ row }">
        <gj-input v-model="row.singleProductNetWeight"></gj-input>
      </template>
      <!-- 单品毛重 -->
      <template v-slot:packageWeight="{ row }">
        <gj-input v-model="row.packageWeight"></gj-input>
      </template>
      <!-- 总净重 -->
      <template v-slot:allSingleProductNetWeight="{ row }">
        {{ calcWeight(row.singleProductNetWeight || 0, row.shipedPlanQuantity || 0) | defaultShow }}
      </template>
      <!-- 总毛重 -->
      <template v-slot:allPackageWeight="{ row }">
        {{ calcWeight(row.packageWeight || 0, row.shipedPlanQuantity || 0) | defaultShow }}
      </template>
      <!-- 总货值 -->
      <template v-slot:productPrice="{ row }">
        {{ calcPlanQuantity(row.purchaseCost || 0, row.arriveCost || 0, row.shipedPlanQuantity || 0) }}
      </template>
      <!-- 备注 -->
      <template v-slot:memo="{row, index}">
        <el-form-item :prop="`items.${index}.memo`" class="gj-table-item">
          <gj-input v-model="row.memo" width="98%" maxlength="200" placeholder="备注">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:op="{index}">
        <gj-button
            type="text" @click="deleteItem(index)">移除
        </gj-button>
      </template>
      <template #footer>
        <div class="table-footer">
          <span style="margin-right: 20px">产品总数：{{ form.items && form.items.length }}</span>
          <span style="margin-right: 20px">总箱数：{{ sumPackageQuantity }}</span>
          <span style="margin-right: 20px">总计划发货量：{{ sumPlanQuantity }}</span>
          <span style="margin-right: 40px">总货值（预估）：{{ sumTotalCost }}</span>
        </div>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
import {OpEnum, ProductEnum} from "@/utils/options";
import AppAddProductModal from "./delivery-plan-add-product";
import AppImportProductModal from "./delivery-plan-add-import";
import {formDeleteItemMixin, formRuleMixin, opTypeMixin, responseMixin, selectionMixin} from "@/minxins";
import {isMeaningful, unique, toFixed} from "@/utils/common";
import GjWarehouseSelect from "@/components/select/gj-warehouse-select";
import {
  getDeliveryPlanTransportOption,
  postWarehouseChangeInfo,
  postTransportChangeInfo, getDeliveryMaxAssemblyQuantity
} from '@/api/logistics'

export default {
  name: "delivery-plan-products",
  mixins: [formRuleMixin, responseMixin, formDeleteItemMixin, opTypeMixin, selectionMixin],
  components: {GjWarehouseSelect},
  props: {
    form: {
      required: true
    },
    opType: {
      required: true
    },
    transferOrder: {
      required: true
    },
    batchEdit: {
      required: true
    },
    transportOptionList: {
      default: () => {
        return {}
      },
      required: false,
    }
  },
  data() {
    return {
      transportValue: '',
      warehouseValue: null,
      transportPopover: false,
      warehouseVisible: false,
      copyColumns: [],
      maxTableDataVo: {
        maxAssemblyQuantity: null,
        voList: []
      },
      maxNumColumns: [
        {id: "picture", header: "图片", field: "picture:imageUrl", width: "50px", align: 'center', default: true},
        {id: "skuName", header: "产品名称/SKU", field: "slot:skuName", minWidth: "160px", default: true,},
        {id: "requiredAmountPerUnit", header: "单位所需量", field: "requiredAmountPerUnit", width: "100px", default: true,},
        {id: "availableQuantity", header: "可用量", field: "availableQuantity", width: "90px", default: true,},
        {id: "alreadyOrderQuantity", header: "已下单", field: "alreadyOrderQuantity", width: "90px", default: true,},
        {id: "planWarehouseQuantity", header: "计划入库", field: "planWarehouseQuantity", width: "90px", default: true,},
      ],
      columns: [
        {
          id: 'imageUrl',
          header: '图片',
          field: 'slot:imageUrl',
          width: '60px',
          align: 'center',
          disabled: true,
          default: true
        },
        {id: 'msku', header: 'MSKU/FNSKU', field: 'slot:msku', width: '160px', default: true},
        {
          id: 'sku',
          header: '产品名称/SKU',
          field: 'slot:sku',
          minWidth: '250px',
          align: 'left',
          default: true,
          disabled: true,
        },
        {
          id: 'singleQuantity',
          header: '单箱数量',
          field: 'slot:singleQuantity',
          width: '120px',
          align: 'left',
          default: true
        },
        {
          id: 'packageQuantity',
          header: '箱数',
          field: 'slot:packageQuantity',
          minWidth: '120px',
          align: 'center',
          default: true
        },
        {
          id: 'shipedPlanQuantity',
          header: '计划发货量',
          required: true,
          field: 'slot:shipedPlanQuantity',
          minWidth: '130px',
          align: 'center',
          default: true,
        },
        {
          id: 'transportId',
          header: 'slot:transportIds:物流方式',
          field: 'slot:transportId',
          minWidth: '200px',
          align: 'center',
          default: true
        },
        {
          id: 'warehouseId',
          header: 'slot:warehouseId:发货仓库',
          field: 'slot:warehouseId',
          minWidth: '200px',
          align: 'center',
          default: true
        },
        {
          id: "areCasesRequired", header: "包装类型", field: "slot:areCasesRequired", width: "120px", default: true, align: 'center',
        },
        {
          id: 'deliveryPlanInbound',
          header: '可用量|已下单|计划入库',
          field: 'slot:deliveryPlanInbound',
          minWidth: '300px',
          align: 'center', default: true
        },
        {id: 'package', header: '包装尺寸（cm）', field: 'slot:package', minWidth: '210px', align: 'center', default: true},
        {id: 'carton', header: '箱规尺寸（cm）', field: 'slot:carton', minWidth: '210px', align: 'center', default: true},
        {
          id: 'cartonSize',
          header: '装箱总体积（m³）',
          field: 'slot:cartonSize',
          help: '装箱总体积 = 单箱体积(m³) * 箱数',
          minWidth: '150px',
          align: 'center',
          default: true
        },
        {
          id: 'singleProductVolumeWeight',
          header: '单品计费重（kg）',
          help: '单品计费重 = 单箱体积(cm³) / 该物流方式的计费重折算系数',
          field: 'slot:singleProductVolumeWeight',
          minWidth: '150px',
          align: 'center', default: true
        },
        {
          id: 'singleProductNetWeight',
          header: '单品净重（g）',
          field: 'slot:singleProductNetWeight',
          minWidth: '120px',
          align: 'center', default: true
        },
        {
          id: 'packageWeight',
          header: '单品毛重（g）',
          field: 'slot:packageWeight',
          minWidth: '120px',
          align: 'center',
          default: true
        },
        {
          id: 'allSingleProductNetWeight',
          header: '总净重（kg）',
          help: '总净重 = 单品净重(kg) * 计划发货量',
          field: 'slot:allSingleProductNetWeight',
          minWidth: '120px',
          align: 'center', default: true
        },
        {
          id: 'allPackageWeight',
          header: '总毛重（kg）',
          field: 'slot:allPackageWeight',
          help: '总毛重 = 单品毛重(kg) * 计划发货量',
          minWidth: '120px',
          align: 'center',
          default: true
        },
        {
          id: 'purchaseCost',
          header: '采购成本（预估）',
          field: 'purchaseCost',
          minWidth: '120px',
          align: 'center',
          default: true, permission: 'cost:view'
        },
        {
          id: 'arriveCost',
          header: '到库成本（预估）',
          field: 'arriveCost',
          minWidth: '120px',
          align: 'center',
          default: true,
          permission: 'cost:view'
        },
        {
          id: 'productPrice',
          header: '总货值（预估）',
          field: 'slot:productPrice',
          help: '总货值(预估) = 计划发货量 *（采购成本（预估）+到库成本（预估））',
          minWidth: '130px',
          align: 'center',
          default: true, permission: 'cost:view',
        },
        {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '240px', align: 'left', default: true}
      ],
      OpEnum: OpEnum,
      productTypeOption: ProductEnum.typeOption,
      transportOption: [],
      maxLoading: false,
      loading: {
        transportId: false
      },
      debounceWarehouseInfo: this._.debounce(this.getWarehouseChangeInfo, 200)
    }
  },
  created() {
    this.initColumns();
  },
  computed: {
    sumPackageQuantity() {
      let sum = 0;
      if (this.form.items && this.form.items.length > 0) {
        this.form.items.forEach(item => {
          if (item.packageQuantity) sum += Number(item.packageQuantity)
        })
      }
      return sum;
    },
    sumPlanQuantity() {
      let sum = 0;
      if (this.form.items && this.form.items.length > 0) {
        this.form.items.forEach(item => {
          if (item.shipedPlanQuantity) sum += Number(item.shipedPlanQuantity)
        })
      }
      return sum;
    },
    sumTotalCost() {
      let sum = 0;
      if (this.form.items && this.form.items.length > 0) {
        this.form.items.forEach(item => {
          if (item.purchaseCost && item.arriveCost && item.shipedPlanQuantity) {
            sum += (Number(item.purchaseCost) + Number(item.arriveCost)) * item.shipedPlanQuantity
          }
        })
      }
      return toFixed(sum,2);
    }
  },
  watch: {
    'form.marketId': {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.getDeliveryPlanTransportOption()
        }
      },
      immediate: true
    }
  },
  methods: {
    hidePopover() {
      document.body.click()
    },
    // 计算计划发货量
    computedShipedPlanQuantity(row, key) {
      if (!row[key]) return;
      if (key === 'singleQuantity') {   // 单箱数量
        if (row['packageQuantity']) {
          row['shipedPlanQuantity'] = row[key] * row['packageQuantity'];
        } else {
          if (row['shipedPlanQuantity']) {
            row['packageQuantity'] = Math.ceil(row['shipedPlanQuantity'] / row['singleQuantity'])
          }
        }
      } else if (key === 'packageQuantity') {  // 箱数
        if (row['singleQuantity']) {
          row['shipedPlanQuantity'] = row[key] * row['singleQuantity'];
        } else {
          if (row['shipedPlanQuantity']) {
            row['singleQuantity'] = Math.ceil(row['shipedPlanQuantity'] / row['packageQuantity'])
          }
        }
      } else {
        if (row['singleQuantity']) {
          row['packageQuantity'] = Math.ceil(row['shipedPlanQuantity'] / row['singleQuantity'])
        }
        if (row['packageQuantity']) {
          row['singleQuantity'] = Math.ceil(row['shipedPlanQuantity'] / row['packageQuantity'])
        }
      }
    },
    // 获取 最大 可用量
    getMaxNums(sku, warehouseId) {
      this.maxTableDataVo = {
        maxAssemblyQuantity: null,
        voList: []
      }
      this.maxLoading = false;
      getDeliveryMaxAssemblyQuantity(sku, warehouseId).then(res => {
        if (isMeaningful(res)) this.maxTableDataVo = res;
      }).complete(() => this.maxLoading = false)
    },
    // 获取单品计费重
    changeTransportId(val, row) {
      let singlePackageVolume = isNaN(Number(row.cartonSizeL) * Number(row.cartonSizeW) * Number(row.cartonSizeH)) ? 0 : Number(row.cartonSizeL) * Number(row.cartonSizeW) * Number(row.cartonSizeH);
      if (val && row.transportId && singlePackageVolume) {
        postTransportChangeInfo([{
          msku: row.msku,
          singlePackageVolume: singlePackageVolume,
          transportId: row.transportId.split('#')[0]
        }]).then((res) => {
          this.$set(row, 'singleProductVolumeWeight', res[0].singleProductVolumeWeight || 0)
        })
      }
    },
    // 获取发货仓库修改后计算结果
    getWarehouseChangeInfo(val, row) {
      if (val) {
        postWarehouseChangeInfo({
          marketId: this.form.marketId,
          mskuList: [row.msku],
          warehouseId: val,
        }).then(([res = {}]) => {
          row.alreadyOrderQuantity = res.alreadyOrderQuantity || 0
          row.availableQuantity = res.availableQuantity || 0
          row.planWarehouseQuantity = res.planWarehouseQuantity || 0
          row.sku = res.sku || 0
        })
      }
    },
    // 计算重量
    calcWeight(weight = 0, num = 0) {
      return ((Number(weight) * Number(num)) / 1000).toFixed(2);
    },
    // 计算总货值
    calcPlanQuantity(cg = 0, yg = 0, num = 0) {
      return (Number(cg) + Number(yg)) * Number(num) ? ((Number(cg) + Number(yg)) * Number(num)).toFixed(2) : "0.00";
    },
    // 计算装箱总体积
    calcCartonSize(l = 0, w = 0, h = 0, xs = 0) {
      return isNaN(((Number(l) * Number(w) * Number(h) * Number(xs)) / 1000000).toFixed(2)) ? 0 : ((Number(l) * Number(w) * Number(h) * Number(xs)) / 1000000).toFixed(2);
    },
    initColumns() {
      if (this.addOpType){
        let find = this.columns.findIndex(v => v.id === 'areCasesRequired');
        this.columns.splice(find,1);
        this.columns.push({id: 'op', header: '操作', field: 'slot:op', width: '50px', align: 'center', fixed: 'right', default: true})
      }
    },
    // 获取物流方式枚举
    getDeliveryPlanTransportOption() {
      if (!this.form.countryCode) return false;
      this.loading.transportId = true
      return getDeliveryPlanTransportOption({
        arrivalCountry: this.form.countryCode
      })
          .then(res => this.transportOption = res)
          .complete(() => this.loading.transportId = false)
    },
    batchTransportId() {
      this.form.items.forEach(item => {
        item.transportId = this.transportValue;
        this.changeTransportId(item.transportId, item);
      })
      this.hidePopover();
    },
    batchWarehouse() {
      this.form.items.forEach(item => {
        item.warehouseId = this.warehouseValue;
        this.getWarehouseChangeInfo(item.warehouseId, item);
      })
      this.hidePopover();
    },
    addProducts() {
      if (!this.form.marketId) {
        this.$gjMessage.warning('请先选择店铺/国家')
        return
      }
      const hideSkuList = this.form?.items || []
      this.$gjCreate(AppAddProductModal, {
        props: {
          hideSkuList: hideSkuList.map(v => v.msku),
          marketId: this.form.marketId,
        },
        on: {
          select: (products) => {
            const items = this.form.items.concat(products.map(item => this.mapToItem(item)));
            this.form.items = unique(items, 'msku');
          }
        }
      })

    },
    importProduct(type) {
      if (!this.form.countryCode) {
        this.$gjMessage.warning("请先选择店铺国家！")
        return false;
      }
      this.$gjCreate(AppImportProductModal, {
        mountTo: this.mountTo,
        props: {
          form: {
            countryCode: this.form.countryCode,
            marketId: this.form.marketId,
            shipPlanImportType: type,
            mskus: this.form.items.length > 0 && type === 'msku' ? this.form.items.map(item => item.msku) : [],
            fnskus: this.form.items.length > 0 && type === 'fnsku' ? this.form.items.map(item => item.fnsku) : []
          },
          type
        },
        on: {
          importSuccess: (data) => {
            this.updateItems(data);
          },
          importPartSuccess: (data) => {
            this.updateItems(data);
          }
        }
      })
    },
    deleteProduct(rows) {
      if (rows.length === 0) return false
      this.$confirm('确定要移除选中产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.forEach(item => {
          const find = this.form.items.findIndex(row => item['msku'] === row['msku']);
          if(find !== -1)  this.form.items.splice(find, 1)
        })
      }).catch(() => {
      });
    },
    updateItems(data) {
      if (isMeaningful(data)) {
        data.forEach(newItem => {
          const find = this.form.items.find(oldItem => newItem['msku'] === oldItem['msku']);
          if (find) {
            Object.assign(find, this.mapToItem(newItem));
          } else {
            this.form.items.push(this.mapToItem(newItem));
          }
        });
      }
    },
    mapToItem(item) {
      let obj = {
        ...item
      };
      if (obj.transportId) {
        obj.transportId = obj.transportId + '#' + obj.transportPrescriptionId
      }
      return obj;
    },
    formValidate() {
      if (this._.isEmpty(this.form.items)) {
        this.$gjMessage.warning('请添加产品');
        return
      }
      let formValid = false;
      this.$refs.form.validate((valid, validObj) => {
        formValid = valid;
        if (!valid) {
          const [ validKey ] = Object.keys(validObj)
          let newKey = validKey.replace(/\./g,'');
          let inputList = document.querySelectorAll(`.${newKey}`)
          inputList && inputList[0] && inputList[0].children && inputList[0].children[0].focus && inputList[0].children[0].focus()
          // this.$refs[validKey] && this.$refs[validKey].focus && this.$refs[validKey].focus()
        }
      })
      return formValid
      // return this.$gjFormValidate();
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ span.el-switch__label.el-switch__label--left.is-active {
  position: relative;
  left: 45px;
  z-index: 200;
  color: #FFFFFF;
}

/deep/ span.el-switch__label.el-switch__label--right.is-active {
  position: relative;
  z-index: 200;
  color: #FFFFFF;
  left: -45px;
}
/deep/ .gj-table--default td:not(.vxe-footer--column){
  height: 56px !important
}

/deep/ .el-switch {
  overflow: hidden;

  &.is-checked {
    .el-switch__label--left {
      visibility: hidden;
      position: relative;
      left: -4005px;
    }
  }

  &:not(.is-checked) {
    .el-switch__label--right {
      visibility: hidden;
      position: relative;
      left: -4005px;
    }

  }
}

.table-footer {
  height: 38px;
  background: #F6F8FB;
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  color: #333333;
  line-height: 38px;
}

.popover-header {
  font-size: 12px;
  color: #333333;
  font-weight: 600;
}

.packageContainer {
  display: flex;

  .package {
    width: 33%;
    &.H /deep/ .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left-color: #FFFFFF;
      &:hover{
        z-index: 3;
        border-left-color: #1F6EEF;
      }
      &:focus{
        z-index: 3;
        border-left-color: #1F6EEF;
      }
    }

    &.L /deep/ .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right-color: #FFFFFF;
      &:hover{
        z-index: 3;
        border-right-color: #1F6EEF;
      }
      &:focus{
        z-index: 3;
        border-right-color: #1F6EEF;
      }
    }
    &.W /deep/ .el-input__inner {
      border-radius: 0;
    }
  }
}
/deep/ .gj-img--tag.el-tag.el-tag--mini.el-tag--light.gj-tag.gj-tag--oval{
  border: none;
  background-color: #d8eaff !important;
  color: #1F6EEF !important;
  position: absolute;
  left: -12px;
  top: -8px;
}

/deep/ .el-input{
  z-index: 1;
}
/deep/ .el-form-item__error{
  z-index: 0;
}
</style>
